import { useTypedSearchParams } from "react-router-typesafe-routes";

import { v2Route } from "~/v2/routes";

export const CATEGORY_TABS = [
  "categories",
  "entityCategoriesTree",
  "relationCategoriesTree",
  "entityCategoriesTable",
  "relationCategoriesTable",
] as const;

export type CategoryTab = (typeof CATEGORY_TABS)[number];

const DEFAULT_TAB: CategoryTab = "categories";

/** Returns the current tab from the `tab-categoriesPage` URL param. */
export function useCategoryTab(): [CategoryTab, (next: CategoryTab) => void] {
  const [params, setParams] = useTypedSearchParams(v2Route.admin.categories);
  const active = params["tab-categoriesPage"] ?? DEFAULT_TAB;

  const setActive = (next: CategoryTab) => {
    setParams((prev) => ({
      ...prev,
      "tab-categoriesPage": next === DEFAULT_TAB ? undefined : next,
    }));
  };

  return [active, setActive];
}
